import React from 'react';
import { isBoolean } from 'lodash';
import { IconButton } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import CodeIcon from '@mui/icons-material/Code';

import { FeatureLeaderboard } from '@models/feature-leaderboard';
import { FeatureLeaderboardFeatureLikes } from '../../components/FeatureLeaderboardFeatureLikes';
import { DrawerMode } from '../FeatureLeaderboardEntryDrawer';

export interface FeatureActions {
  edit: boolean;
  copy: boolean;
  code: boolean;
}

export interface FeatureActionsProps {
  isWithActions?: Partial<FeatureActions> | boolean;
  isWithLikes?: boolean;
}

interface FeatureLeaderboardEntryActionsProps extends FeatureActionsProps {
  mode: DrawerMode;
  onModeChange: (mode: DrawerMode) => void;
  featureEntry: FeatureLeaderboard.Entry;
}

function isWithAction(
  actionName: keyof FeatureActions,
  isWithActions?: Partial<FeatureActions> | boolean
): boolean {
  return isBoolean(isWithActions)
    ? isWithActions
    : isWithActions?.[actionName] ?? true;
}

export const FeatureLeaderboardEntryActions = (
  props: FeatureLeaderboardEntryActionsProps
) => {
  const isWithEditAction = isWithAction('edit', props.isWithActions);
  const isWithCopyAction = isWithAction('copy', props.isWithActions);
  const isWithCodeAction = isWithAction('code', props.isWithActions);
  const isWithLikes = props.isWithLikes ?? true;

  return (
    <div style={{ marginLeft: 'auto', display: 'flex', gap: '5px' }}>
      <div className="fl-entry-row-actions">
        <div className="fl-entry-row-hidden-actions">
          {isWithEditAction ? (
            <IconButton
              color="primary"
              size="small"
              onClick={() => props.onModeChange(DrawerMode.Edit)}
            >
              <ModeEditIcon className="action-btn" />
            </IconButton>
          ) : null}
          {isWithCopyAction ? (
            <IconButton
              color="primary"
              size="small"
              onClick={() => props.onModeChange(DrawerMode.Copy)}
            >
              <CopyAllIcon className="action-btn" />
            </IconButton>
          ) : null}
          {isWithCodeAction ? (
            <IconButton
              color="primary"
              size="small"
              onClick={() => props.onModeChange(DrawerMode.Code)}
            >
              <CodeIcon className="action-btn" />
            </IconButton>
          ) : null}
        </div>
      </div>
      {isWithLikes ? (
        <FeatureLeaderboardFeatureLikes
          featureId={props.featureEntry.feature.id}
        />
      ) : null}
    </div>
  );
};
